import React, { Component } from 'react';
import {NativeSelect, InputLabel, FormControl} from '@material-ui/core';

class DropDown extends Component {
    constructor(props) {
        super(props);
        this.state =  {
            fieldValue: '',
        }
    }

    componentDidMount() {
        if (this.props.editRecord){
           let initVal =  this.props.editRecord[this.props.fieldMap.field];
           if (!initVal){initVal = ''}
           this.setState({fieldValue:initVal});
           this.props.setField({field:this.props.fieldMap.field, value:initVal});
        }
    }

    renderOptions = () => {
        let outArray = [];
        if (this.props.listArray.length>0){
            const keysArray = Object.keys(this.props.listArray[0]);
            outArray.push(<option key={0} value={''}></option>);
            for (var i=0;i<this.props.listArray.length;i++){
                outArray.push(<option key={i+1} value={this.props.listArray[i][keysArray[0]]}>{this.props.listArray[i][keysArray[1]]}</option>);
            }
        } else {
            outArray.push(<option key={0} value={''}>--Error--</option>)
        }
        return outArray;
    }

    resetMe = () => {
        this.setState({fieldValue:''})
    }

    render() {
        const spec = this.props.fieldMap;  
        return (
            <FormControl required={spec.f_required} fullWidth={this.props.fullwidth? true : false}>            
                <InputLabel htmlFor={spec.field}>{spec.headerName}</InputLabel>
                <NativeSelect 
                    id={spec.field}
                    fullWidth={true}
                    
                    value={this.state.fieldValue}
                    disabled={this.props.disabled}
                    variant="outlined"
                    onChange={this.handleChange}
                >
                    {this.renderOptions()}    
                </NativeSelect>
            </FormControl>
        );
    }

    handleChange = (e) => {
        // console.log('Updated value: ',e.target.value);
        this.setState({fieldValue:e.target.value});
        this.props.setField({field:e.target.id, value:e.target.value});
    }
}

export default DropDown;